import { WorldTransform } from "./WorldTransform";
import { Matrix, Quaternion, Vector3, Vector4 } from "@babylonjs/core/Maths/math.vector.js";
export class WorldTransform3dof extends WorldTransform {
    constructor(params) {
        super(params);
        this._neckModel = { upward: -0.15, forward: -0.10 };
        this._hasNeck = false;
        this._skipChangePosTimes = 3; // In order to avoid jumping the lobby after initialization
        this._onXRFrame = (_frame) => {
            this._changePose3dof();
        };
        if (params.isEmulation) {
            this._skipChangePosTimes = 0;
        }
        else {
            this._guiParentNode.position = new Vector3(0, 0, -50);
        }
        this._changePose3dof();
        params.xrHelper?.baseExperience.sessionManager.onXRFrameObservable.add(this._onXRFrame);
    }
    evaluateAndSetPose() {
        this._changePose3dof();
    }
    _changePose3dof() {
        const camera = this._scene.activeCamera;
        if (!camera) {
            return;
        }
        if (camera.position.lengthSquared() < 0.001) {
            return;
        }
        if (this._skipChangePosTimes > 0) {
            this._skipChangePosTimes--;
            return;
        }
        // // Console output utils:
        // const n2s = (n: number): string => {
        //     return n.toFixed(2);
        // }
        // const v2s = (v: Vector4): string => {
        //     return `${n2s(v.x)}\t${n2s(v.y)}\t${n2s(v.z)}\t${n2s(v.w)}`;
        // }
        // const m2s = (m: Matrix): string => {
        //     let s = "";
        //     s += `${v2s(m.getRow(0)!)}\n`;
        //     s += `${v2s(m.getRow(1)!)}\n`;
        //     s += `${v2s(m.getRow(2)!)}\n`;
        //     s += `${v2s(m.getRow(3)!)}`;
        //     return s;
        // }
        let newPosition;
        if (this._hasNeck) {
            // Math comment:
            //   worldToCamera = worldToNeck * neckToCamera
            //   worldToCamera * neckToCamera^-1 = worldToNeck * neckToCamera * neckToCamera^-1
            //   worldToNeck = worldToCamera * neckToCamera^-1
            //   worldToNeck = worldToCamera * cameraToNeck
            const worldToCamera = camera.getWorldMatrix();
            const cameraToNeck = Matrix.Identity();
            cameraToNeck.setRow(3, new Vector4(0, this._neckModel.upward, this._neckModel.forward, 1));
            const worldToNeck = worldToCamera.multiply(cameraToNeck);
            // Use neck model:
            const neckPos4 = worldToNeck.getRow(3);
            newPosition = new Vector3(neckPos4.x, neckPos4.y - this._neckModel.upward, neckPos4.z);
        }
        else {
            // Do not use neck model:
            const cameraPosition = camera.position;
            newPosition = new Vector3(cameraPosition.x, cameraPosition.y, cameraPosition.z);
        }
        this._moveWorld(newPosition);
    }
    recenter() {
        this._moveWorld(Vector3.Zero());
        const rot = (this._scene.activeCamera?.absoluteRotation ?? Quaternion.Identity()).toEulerAngles();
        rot.x = 0;
        rot.z = 0;
        this._guiParentNode.rotationQuaternion = rot.toQuaternion();
    }
}
